// Copyright (c) 2026 Vigeos SASU. Tous droits réservés.
import { create } from 'zustand';
import { SESSION_KEY, revokeSession } from '../utils/api';

// Un seul magasin, la session : chaque écran interroge l'API directement.

export const useAuthStore = create((set) => ({
  token: localStorage.getItem(SESSION_KEY) || null,

  login: (token) => {
    localStorage.setItem(SESSION_KEY, token);
    set({ token });
  },

  // Le serveur d'abord, avec le jeton courant, puis la session locale : une
  // fois localStorage effacé, il n'y a plus de jeton à révoquer. L'échec de
  // l'appel n'empêche jamais la déconnexion locale (voir revokeSession).
  logout: async () => {
    const currentToken = localStorage.getItem(SESSION_KEY);
    try {
      await revokeSession(currentToken);
    } finally {
      localStorage.removeItem(SESSION_KEY);
      set({ token: null });
    }
  },
}));
